// Design tokens for the airun.art redesign (from design_handoff_airun_redesign/README.md).
//
// NOTE: the app intentionally has NO MUI ThemeProvider (see AppShell.js) — it runs on
// MUI defaults. So these are plain constants applied via explicit `sx`/style values,
// NOT a MUI theme. Import what you need and spread/reference it in `sx`.

export const COLORS = {
  // Brand blue (active / selection)
  blue: '#2196F3',
  blueText: '#1877D2', // hover / text on light blue
  blueBg: '#EAF3FE', // light blue fill
  blueBorder: '#CFE4FA',
  blueTile: '#EFF4FA', // sidebar inactive icon tile

  // Text
  heading: '#1A1D24',
  heading2: '#23272F',
  textSecondary: '#8A8F98',
  muted: '#9AA0A8',
  muted2: '#AEB3BB',
  body: '#4A4F57',
  bodyStrong: '#5A5F68',
  name: '#2A2E37',
  sectionLabel: '#A2A8B0',

  // Borders
  cardBorder: '#ECECEF',
  fieldBorder: '#E2E4E9',
  fieldBorder2: '#E4E7EC',
  divider: '#F0F0F2',
  softBorder: '#EDEFF2',

  // Backgrounds
  card: '#fff',
  content: '#F7F8FA',
  soft: '#FBFBFC',
  dropzone: '#FAFBFC',
  segTrack: '#EEF0F4',

  // States / badges
  success: '#10B981',
  hit: '#EF4444',
  star: '#F5A623',

  purple: '#764ba2',
  indigo: '#667eea',
};

// Per-tool accent colors (match SidebarMenu tool ids).
export const TOOL_ACCENTS = {
  'auto-product-card': '#10B981',
  'replace-model': '#6366F1',
  'replace-background': '#8B5CF6',
  photosession: '#EC4899',
  'photo-generation': '#0EA5E9',
  'photo-to-video': '#F59E0B',
  'video-merge': '#10B981',
};

export const GRADIENTS = {
  // Run / CTA / balance
  purple: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  purpleHover: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
  // Logo / wordmark
  wordmark: 'linear-gradient(135deg, #10cefb 0%, #764ba2 100%)',
};

export const RADII = {
  card: 16, // px — cards / windows
  field: 12, // fields / panels
  button: 14,
  pill: 20,
  chip: 16,
  tileSidebar: 9,
  tileLanding: 17,
  seg: 11,
  segItem: 8,
};

export const SHADOWS = {
  card: '0 1px 3px rgba(0,0,0,0.04)',
  cardHover: '0 16px 34px rgba(20,24,45,0.10)',
  run: '0 6px 18px rgba(118,75,162,0.30)',
  cta: '0 8px 22px rgba(118,75,162,0.30)',
  sidebarActive: '0 4px 12px rgba(33,150,243,0.28)',
  segItem: '0 1px 3px rgba(0,0,0,0.09)',
};

export const FONT_STACK =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export default { COLORS, TOOL_ACCENTS, GRADIENTS, RADII, SHADOWS, FONT_STACK };
